import React from 'react';
import styles from './InboxList.module.scss';
import { useFetchUsers } from '../../../../../Hooks/Users';

const InboxFilter = ({
  selectedFilter,
  setSelectedFilter,
  selectedSort,
  setSelectedSort,
  setSelectedLink,
  selectedLink,
}) => {
  const { data: users } = useFetchUsers({
    pageSize: 2000,
    pageNumber: 1,
    selected: true,
  });
  const dropdownOptions = [
    {
      title: 'Filter by',
      subCategories: [
        { name: 'All', key: 'starred' },
        { name: 'Unread', key: 'unread' },
      ],
      selected: selectedFilter,
      handler: setSelectedFilter,
    },
    {
      title: 'Sort by',
      subCategories: [
        { name: 'Newest to top', key: 'newest' },
        { name: 'Oldest to top', key: 'oldest' },
      ],
      selected: selectedSort,
      handler: setSelectedSort,
    },
    {
      title: 'Assigned to',
      subCategories:
        users?.data?.items
          ?.filter((u) => u.isRequirement)
          ?.map((i) => ({
            name: `${i.firstNameEn} ${i.lastNameEn}`,
            key: i.userId,
          })) || [],
      selected: selectedLink,
      handler: setSelectedLink,
    },
  ];
  console.log('nhghghgn', dropdownOptions);
  return dropdownOptions.map((section) => (
    <div key={section.title} className={styles.dropdownSection}>
      <p className={styles.dropdownTitle}>{section.title}</p>

      {section.subCategories.map((sub, i) => (
        <div
          key={sub.key}
          className={`${styles.dropdownItem} ${i % 2 !== 0 ? styles.odd : ''} ${
            section.selected === sub.key ? styles.active : ''
          }`}
          onClick={() =>
            section.handler(section.selected === sub.key ? '' : sub.key)
          }
        >
          {section.selected === sub.key && <span>✔</span>}
          <span>{sub.name}</span>
        </div>
      ))}
    </div>
  ));
};

export default InboxFilter;
